export enum SuppliersPermissions {
  GET_SUPPLIERS = 'suppliers.getSuppliers',
  PERSIST_SUPPLIER = 'suppliers.persistSupplier',
  ARCHIVE_SUPPLIER = 'suppliers.archiveSupplier',
  GET_COLLECTION_MANAGEMENT_VIEW = 'suppliers.getCollectionManagementView',
}
